module.exports = __webpack_public_path__ + "img/org-icon.1ef4b481.svg";